import { IListResponse, XHRInstance } from "@sembark-travel/xhr"
import { IMealPlan } from "../MealPlans"
import { IRoomType } from "../RoomTypes"
import { TTripDestination } from "../TripDestinations"

export type THotelNote = {
	id: number
	hotel_id: number | null
	meal_plans?: IMealPlan[]
	room_types?: IRoomType[]
	show_in_quote: 0 | 1
	show_in_voucher: 0 | 1
	description: string
	date_ranges?: Array<{ start_date?: string; end_date?: string }>
	destinations?: Array<TTripDestination>
}
export function hotelNotesXHR(xhr: XHRInstance) {
	return {
		async getGlobalHotelNotes(
			params?: Record<string, unknown>
		): Promise<IListResponse<THotelNote>> {
			return xhr
				.get("/hotel-notes", { params: { ...params } })
				.then((resp) => resp.data)
		},
		async destroyNote(id: number | string) {
			return xhr
				.delete<{ message: string }>(`/hotel-notes/${id}`)
				.then((res) => res.data)
		},
	}
}
